import { CompareDirection } from '@apps/app.constants';
import { Comparer } from '../services/utils.service';

export class HeaderComparer<T>
{
    comparer: Comparer<T>;
    defaultDirection: CompareDirection;

    constructor (comparer: Comparer<T>, dir: CompareDirection = CompareDirection.ASC)
    {
        this.comparer = comparer;
        this.defaultDirection = dir;
    }
}

export abstract class ListComponent<T>
{
    private _currentSorterKey: string = undefined;
    get currentSorterKey (): string
    {
        return this._currentSorterKey;
    }
    private _currentDirection: CompareDirection;
    get currentDirection (): CompareDirection
    {
        return this._currentDirection;
    }
    protected headerComparers: Map<string, HeaderComparer<T>>;
    public direction: CompareDirection = CompareDirection.NONE;
    protected getNextDirection (direction: CompareDirection): CompareDirection
    {
        return direction === CompareDirection.ASC
            ? CompareDirection.DESC
            : direction === CompareDirection.DESC
                ? CompareDirection.NONE
                : CompareDirection.ASC;
    }

    protected getComparer (sorterKey: string): { comparer: Comparer<T>, direction: CompareDirection }
    {
        const hc: HeaderComparer<T> = this.headerComparers.get(sorterKey);

        if (this._currentSorterKey === undefined || this._currentSorterKey !== sorterKey)
        {
            this._currentSorterKey = sorterKey;
            this._currentDirection = hc.defaultDirection;
        }
        else
        {
            this._currentDirection = this.getNextDirection(this._currentDirection);
        }

        return { comparer: hc.comparer, direction: this._currentDirection };
    }

    public clickedColumn (sorterKey: string): void
    {
        this.sortList(sorterKey);
    }

    protected abstract sortList (sorterKey: string): void;
}
